import * as React from "react"
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core";
import {Box, Typography} from "@mui/material";
import {formatAbbreviateNumber, formatDate, formatNumber} from "@ui-seeker/utils";
import {useSignal} from "@preact/signals-react";
import ProductPagesDetailsModalRating from "./Modal";


export default function ProductPagesDetailsModalRatingContent({ rating, reviews, lastReview, data }) {
	const openModal = useSignal(false)

	if (!rating)
		return <></>

	return <>
		<TooltipSeeker title='Show rating details'>
			<Box sx={{ display: "flex", flexWrap: "wrap", cursor: "pointer", mt: 2 }} onClick={() => openModal.value = true}>
				<Box sx={{ flex: "10%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					{ !!reviews && <Typography fontSize={20} float="left" position="relative">
						<IconSeeker icon="star-exclamation" />
					</Typography>
					}
				</Box>
				<Box sx={{ flex: "90%" }}>
					<Box sx={{ mt: 0.5 }}>
						{ !!reviews && <Typography fontWeight='bold' fontSize={16}>
							Reviews: {formatAbbreviateNumber(reviews)}
						</Typography>
						}
					</Box>
					{/* `!!` matters: `lastReview` is the raw `last_review_date`, and a product page
					    with no individual review carries the **integer 0** — Amazon captures the
					    aggregate rating but not the last review. `0 && …` evaluates to `0`, which
					    React renders, so this used to print a bare "0" between Reviews and Rating. */}
					{ !!lastReview && <Box>
						Last Review: {formatDate(lastReview, {isString: true})}
					</Box> }

					<Box sx={{ pr: 0.5, pt: 1.2 }}>
						<Typography fontWeight='bold' fontSize="16">
							Rating: {formatNumber(rating, { decimals: 1 })}
						</Typography>
					</Box>
				</Box>
			</Box>
		</TooltipSeeker>

		<ProductPagesDetailsModalRating
			isOpen={openModal.value}
			controller={() => openModal.value = false}
			rating={rating}
			reviews={reviews}
			data={data}
		/>
	</>
}